import { Link } from 'react-router-dom';
import { works } from '@/mocks/works';
import { formatCount } from '@/utils/format';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function RankingSection() {
  const sorted = [...works].sort((a, b) => a.rank - b.rank);
  const top = sorted[0];
  const rest = sorted.slice(1, 6);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="每日 09:00 / 18:00 更新"
            title="热门作品榜"
            description="按浏览增量、点赞比例与讨论时长综合排序，长尾讨论更容易排到前面。"
            action={{ to: '/works', label: '查看完整合集' }}
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <Reveal className="lg:col-span-3">
            <article className="flex h-full flex-col overflow-hidden rounded-lg border border-primary-200 bg-background-50">
              <Link to={`/works/${top.id}`} className="relative block h-64 w-full overflow-hidden md:h-80">
                <img
                  src={top.cover}
                  alt={`${top.title} - 黑料大赛热门作品榜第一名`}
                  title={`${top.title} - 黑料大赛热门作品`}
                  className="h-full w-full object-top transition-transform duration-500 hover:scale-[1.03]"
                />
                <span className="absolute left-4 top-4 flex items-center gap-2 rounded-md bg-primary-500 px-3 py-1.5 font-label text-xs text-background-50">
                  <i className="ri-trophy-line"></i>
                  榜单第 1 名
                </span>
              </Link>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2 font-label text-xs text-foreground-500">
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-accent-900">{top.category}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-3-line"></i>
                    {top.contestant}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatCount(top.views)}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  <Link to={`/works/${top.id}`} className="transition-colors hover:text-primary-600">
                    {top.title}
                  </Link>
                </h3>
                <p className="mt-3 line-clamp-3 font-body text-sm leading-relaxed text-foreground-600">
                  {top.summary}
                </p>
                <Link
                  to={`/works/${top.id}`}
                  className="mt-auto inline-flex w-fit items-center gap-1.5 whitespace-nowrap pt-5 font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
                >
                  阅读全文
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          </Reveal>

          <Reveal delay={120} className="lg:col-span-2">
            <ol className="flex h-full flex-col gap-3">
              {rest.map((work) => (
                <li key={work.id}>
                  <Link
                    to={`/works/${work.id}`}
                    className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
                  >
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-200 font-heading text-sm font-bold text-foreground-700">
                      {work.rank}
                    </span>
                    <div className="h-14 w-20 shrink-0 overflow-hidden rounded-md">
                      <img
                        src={work.cover}
                        alt={`${work.title} - 黑料大赛热门作品`}
                        title={`${work.title} - 黑料大赛参赛作品`}
                        className="h-full w-full object-top"
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate font-heading text-sm font-bold text-foreground-950">{work.title}</h3>
                      <p className="mt-1 flex items-center gap-2 font-label text-xs text-foreground-500">
                        <span className="truncate">{work.contestant}</span>
                        <span className="text-foreground-300">·</span>
                        <span>热度 {work.heat}</span>
                      </p>
                    </div>
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </Link>
                </li>
              ))}
            </ol>
          </Reveal>
        </div>
      </div>
    </section>
  );
}